import { useAutoAnimate } from '~/common/hooks/useAutoAnimate';
import { Button } from '@mantine/core';
import { useForm } from '@mantine/form';
import type { SelectedOperation } from '~/server/logic/prisma/operation-select';
import { type AIActionModel } from '~/server/logic/steps/operation/types';
import { AIActionConfig } from './AIActionConfig';

export default function AIActionOpConfig({
  operation,
  onClose,
  onSave,
  readonly,
  optimisticPrompt,
}: {
  operation: SelectedOperation;
  onClose: () => void;
  onSave: (values: { prompt: string; model: AIActionModel }) => void;
  readonly?: boolean;
  optimisticPrompt?: string;
}) {
  const [animationParent] = useAutoAnimate();

  const form = useForm<{
    prompt: string;
    model: AIActionModel;
  }>({
    initialValues: {
      prompt: optimisticPrompt || operation.aiActionOp?.prompt || '',
      model: operation.aiActionOp?.model || 'STABLY_FLASH',
    },
  });

  return (
    <form
      onSubmit={form.onSubmit(onSave)}
      ref={animationParent}
    >
      <div className="space-y-6">
        <AIActionConfig
          readonly={readonly}
          className="mt-2"
          prompt={form.values.prompt}
          model={form.values.model}
          onPromptChange={(value) => form.setFieldValue('prompt', value)}
          onModelChange={(value) => form.setFieldValue('model', value)}
          promptTitle="Prompt"
        />

        {!readonly && (
          <div className="mt-2 flex justify-end gap-2">
            <Button
              variant="subtle"
              onClick={onClose}
              size="xs"
              className="text-gray-600 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              size="xs"
            >
              Save
            </Button>
          </div>
        )}
      </div>
    </form>
  );
}
